<template>
  <div class="col-12">
    <div class="row" v-if="Object.keys(chartData).length > 0">
      <div class="col-12 mb-2">
        <div class="d-flex justify-content-between">
          <button class="btn btn-primary" @click="getPreviousMonth()">
            <i class="fas fa-angle-double-left"></i>
            {{previousDate.getFullYear() }}年 {{previousDate.getMonth() + 1}}月
          </button>
          <div v-if="nextDate < currentDate">
            <button class="btn btn-primary" @click="getNextMonth()">
              {{nextDate.getFullYear() }}年 {{nextDate.getMonth() + 1}}月
              <i class="fas fa-angle-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="card">
          <div class="card-body">
            <div class="page-title-box">
              <div class="page-title-btn float-right">
                <button @click="downloadCsv('viewed_month')" class="btn btn-primary btn-rounded">CSVダウンロード</button>
              </div>
              <h4 class="page-title header-title">{{year}}年 {{month + 1}}月 視聴回数/日</h4>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th v-for="c in chartData.month">
                    <div class="text-nowrap text-right">
                      <a class="btn btn-light btn-block" href="#">{{c.label}}</a>
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="c in chartData.month">
                    <div class="text-nowrap text-right">
                      <a class="btn btn-light btn-block" href="#">{{c.total}}</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <bar-chart :chartdata="chartData.month" chart_id="viewed_of_day" bar_label="視聴回数" :bar_color="bar_color"></bar-chart>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="card">
          <div class="card-body">
            <div class="page-title-box">
              <div class="page-title-btn float-right">
                <button @click="downloadCsv('viewed_year')" class="btn btn-primary btn-rounded">CSVダウンロード</button>
              </div>
              <h4 class="page-title header-title">{{year}}年 視聴回数/月</h4>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th v-for="c in chartData.year">
                      <div class="text-nowrap text-right">
                        <a class="btn btn-light btn-block" href="#">{{c.label}}</a>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="c in chartData.year">
                      <div class="text-nowrap text-right">
                        <a class="btn btn-light btn-block" href="#">{{c.total}}</a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <bar-chart :chartdata="chartData.year" chart_id="viewed_of_month" bar_label="視聴回数" :bar_color="bar_color"></bar-chart>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <div class="card">
          <div class="card-body">
            <div class="page-title-box">
              <div class="page-title-btn float-right">
                <button @click="downloadCsv('viewed_time')" class="btn btn-primary btn-rounded">CSVダウンロード</button>
                <h6>視聴時間合計：{{chartData.watched_average}}（分）</h6>
              </div>

              <h4 class="page-title header-title">視聴時間</h4>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th v-for="c in chartData.watched">
                    <div class="text-nowrap text-right">
                      {{c.label}}
                    </div>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td v-for="c in chartData.watched">
                    <div class="text-nowrap text-right">
                      {{c.total}}
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <bar-chart :chartdata="chartData.watched" chart_id="average_viewing" bar_label="視聴時間" :bar_color="bar_color"></bar-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import BarChart from "../../shared/BarChart";

  export default {
    props: {
      series_id: {
        type: Number,
        default: null
      },
      bar_color: {
        type: String,
        default: "#2196f3"
      }
    },
    components: {BarChart},
    data() {
      return {
        currentDate: new Date(),
        date: new Date(),
        month: new Date().getMonth(),
        year: new Date().getFullYear(),
        previousDate: null,
        nextDate: null,
        chartData: {}
      }
    },
    methods: {
      initDate() {
        const month = this.getParam("month")
        const year  = this.getParam("year")

        if(month && year){
          this.date = new Date(year, month - 1, 1)
          if (this.date > this.currentDate){
            this.date = this.currentDate
          }
        }
        this.year  = this.date.getFullYear()
        this.month = this.date.getMonth()

        this.previousDate = new Date(this.year, this.month - 1, 1)
        this.nextDate     = new Date(this.year, this.month + 1, 1)
      },
      async getSeriesVideo() {
        let href = "/api/v1/admin/series/" + this.series_id + "?date=" + this.date;
        await this.axios.get(href).then((response) => {
          this.chartData = response.data.chartdata
        }).catch((error) => {})
      },
      getParam(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&")
        let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url)
        if (!results) return null
        if (!results[2]) return ''
        return decodeURIComponent(results[2].replace(/\+/g, " "))
      },
      getPreviousMonth() {
        const href = location.pathname = "?month=" + (this.previousDate.getMonth() + 1) + "&year=" + this.previousDate.getFullYear()
        location.href = href
      },
      getNextMonth() {
        const href = location.pathname = "?month=" + (this.nextDate.getMonth() + 1) + "&year=" + this.nextDate.getFullYear()
        location.href = href
      },
      downloadCsv(type) {
        let href = "/api/v1/admin/series/" + this.series_id + ".csv?date=" + this.date + "&type=" + type;
        open(href);
      }
    },
    mounted() {
      this.initDate()
      this.getSeriesVideo()
    }
  }
</script>
